import { Box, Center, Image, Stack, useMantineColorScheme } from "@mantine/core";

import NoCars from "../../../assets/illustrations/NoCars.svg";
import NoCarsDarkMode from "../../../assets/illustrations/NoCars_DarkMode.svg";
import NoData from "../../../assets/illustrations/NoData.svg";
import NoDataDarkMode from "../../../assets/illustrations/NoData_DarkMode.svg";
import NoResults from "../../../assets/illustrations/NoResults.svg";
import NoResultsDarkMode from "../../../assets/illustrations/NoResults_DarkMode.svg";
import NoNotifications from "../../../assets/illustrations/noNotifications.svg";
import NoNotificationsDarkMode from "../../../assets/illustrations/noNotificationsDarkMode.svg";

import { TextSerif } from "@/components/elements";

import type { MantineStyleProps } from "@mantine/core";
import type { FC, PropsWithChildren } from "react";

export type EmptyStateProps = PropsWithChildren<{
  gutter?: number;
  objectFit?: "contain" | "cover" | "fill" | "none" | "scale-down" | "unset";
  text?: string;
  type: "noData" | "noResults" | "noCars" | "noNotifications";
}> &
  MantineStyleProps;

export const EmptyState: FC<EmptyStateProps> = ({
  children,
  gutter = 50,
  objectFit,
  text,
  type,
  ...props
}) => {
  const { colorScheme } = useMantineColorScheme();

  const isDark = colorScheme === "dark";

  const getIllustration = () => {
    switch (type) {
      case "noData":
        return <Image src={isDark ? NoDataDarkMode : NoData} alt="No data" h={130} />;
      case "noResults":
        return <Image src={isDark ? NoResultsDarkMode : NoResults} alt="No results" h={130} />;
      case "noCars":
        return (
          <Image
            src={isDark ? NoCarsDarkMode : NoCars}
            alt="No cars"
            h={130}
            style={{ objectFit: objectFit ?? "cover" }}
          />
        );
      case "noNotifications":
        return (
          <Image
            src={isDark ? NoNotificationsDarkMode : NoNotifications}
            alt="No notifications"
            h={130}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Center {...props}>
      <Box py={gutter}>
        <Stack align="center" gap="md">
          {getIllustration()}
          {text && <TextSerif ta="center">{text}</TextSerif>}
          {children}
        </Stack>
      </Box>
    </Center>
  );
};
